import { render, staticRenderFns } from "./standardList.vue?vue&type=template&id=e067a54a&scoped=true"
import script from "./standardList.vue?vue&type=script&lang=js"
export * from "./standardList.vue?vue&type=script&lang=js"
import style0 from "./standardList.vue?vue&type=style&index=0&id=e067a54a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e067a54a",
  null
  
)

export default component.exports